// Web-specific Amplitude imports - only in browser environment
let amplitudeModule: any = null

// Lazy load Amplitude to prevent SSR issues
const getAmplitude = () => {
  if (typeof window === 'undefined') {
    // Return no-op functions for SSR/build time
    return {
      init: () => Promise.resolve(),
      track: () => {},
      setUserId: () => {},
      Identify: function() { return { set: () => {} } },
      Revenue: function() {},
    }
  }

  if (!amplitudeModule) {
    amplitudeModule = require('@amplitude/analytics-browser')
  }
  return amplitudeModule
}

// Configuration for web
export const STORAGE_CONFIG = {
  storage: {
    storage: {
      type: 'localStorage',
    },
    // Disable cookies since they can cause issues in iOS Safari
    cookies: {
      enabled: false,
    },
  },
  tracking: {
    // Disable file download tracking which causes addEventListener errors
    fileDownloads: false,
    pageViews: true,
    sessions: true,
    formInteractions: false,
  },
}

// Re-export functions with SSR safety
export const init = (apiKey: string, config?: any) => getAmplitude().init(apiKey, config)
export const track = (eventName: string, properties?: any) => getAmplitude().track(eventName, properties)
export const setUserId = (userId?: string) => getAmplitude().setUserId(userId)
export const Identify = () => new (getAmplitude().Identify)()
export const Revenue = () => new (getAmplitude().Revenue)()

// Platform identifier
export const PLATFORM = 'web'

// Web-specific functions
export const isLocalhost = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  )
}
